import React from "react";
import experience from "../../data/experience.js";

const Experience = () => {
  return (
    <div className="new-tab-content-container">
      <div className="education-container">
        <h1>Experience</h1>
        <div className="education-cover">
          {experience.map((e, i) => (
            <section className="new-experience-card" key={i}>
              <img className="company-logo" src={e.image} alt="photo" />
              <div>
                <strong className="c-typography">
                  <span>Role: </span>
                  {e.title}
                </strong>
                <p className="c-typography">
                  <span>Company: </span>
                  {e.company}
                </p>
                <p className="c-typography">
                  <span>Duration: </span>
                  {e.period}
                </p>
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
